import { getRequestOptionDemoMode } from '@/utils/demoMode';
import { getStorageCompanyId } from '@/utils/localStorage';
import { request } from 'umi';

export async function getCampaignListApi(
  params: API.CampaignListGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.CampaignList>('/campaign/list', {
    params: { ...params, companyId },
    ...options,
  });
}

export async function getCampaignDetailApi(
  params: API.CampaignDetailGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.CampaignDetail>('/campaign/detail', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode('name'),
  });
}

export async function getCampaignDetailChartApi(
  params: API.CampaignDetailMetricsChartGetParameters,
  options?: API.RequestOptions,
) {
  const companyId = getStorageCompanyId();
  return request<API.CampaignDetailMetricsChart>('/campaign/detail/chart', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode('name'),
  });
}

export const getCampaignSpendingAPI = async (
  params: API.CampaignSpendingGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.CampaignSpending>('/campaign/spending', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getCampaignPurchasesAPI = async (
  params: API.CampaignPurchasesGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.CampaignPurchases>('/campaign/purchases', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getCampaignNewUsersAPI = async (
  params: API.CampaignNewUsersGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.CampaignNewUsers>('/campaign/new_users', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getCampaignAllAPI = async (
  params: API.CampaignAllGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  const { media, ...restParams } = params;
  const mediaQueryStr = media.map((mediaStr) => `media=${mediaStr}`).join('&');
  return request<API.CampaignAll>(`/campaign/all?${mediaQueryStr}`, {
    params: { ...restParams, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getCampaignMonthlyAPI = async (
  params: API.CampaignMonthlyGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  const { media, ...restParams } = params;
  const mediaQueryStr = media.map((mediaStr) => `media=${mediaStr}`).join('&');
  return request<API.CampaignAll>(`/campaign/monthly?${mediaQueryStr}`, {
    params: { ...restParams, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getCampaignStatusAPI = async (options?: API.RequestOptions) => {
  const companyId = getStorageCompanyId();
  if (!companyId || companyId === 'undefined') {
    return Promise.resolve({
      data: {
        status: 'inactive',
      },
    } as any);
  }
  return request<API.CampaignStatus>('/campaign/status', { params: { companyId }, ...options });
};
